import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import sq from './sq.json';
import mk from './mk.json';
import de from './de.json';

const savedLanguage = localStorage.getItem('language') || 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    sq: { translation: sq },
    mk: { translation: mk },
    de: { translation: de },
  },
  lng: savedLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
